export default [
  {
    path: '/orders',
    name: 'Orders',
    meta: {
      requireAuth: true,
      requireFields: true,
      // Order History is feature-flagged — users without `order_page` get
      // redirected to `/` by the global `requireFlag` guard.
      requireFlag: 'order_page',
    },
    component: () => import('@/views/Orders/index.vue'),
  },
]
